"use client";

import { c as _c } from "react/compiler-runtime";
import { FeedbackButton } from "@/app/components/FeedbackButton/FeedbackButton";
import { HydrationGate } from "@/app/components/HydrationGate/HydrationGate";
import { StepLoader } from "@/app/components/StepLoader/StepLoader";
import { useAppContext } from "@/app/contextProviders/app-context";
import { IntlProviderWrapper } from "@/app/contextProviders/intl-provider-wrapper";
import { SchedulerMachineProvider } from "@/app/contextProviders/scheduler-machine-provider";
import type { DigitalVisitReasonEnum } from "@/lib/__generated/api";
import Header from "./components/Header/Header";
import SchedulerContent from "./SchedulerContent";
import styles from "./SchedulerShell.module.css";
interface SchedulerShellProps {
  initialReason?: DigitalVisitReasonEnum;
}
export default function SchedulerShell(t0) {
  const $ = _c(16);
  const {
    initialReason
  } = t0;
  const {
    currentFacility,
    stateCode,
    restUrl,
    recaptchaSiteKey,
    featureFlags,
    reloadFacilityByCode
  } = useAppContext();
  let t1;
  if ($[0] !== initialReason) {
    t1 = initialReason ? <HydrationGate fallback={<StepLoader />}><SchedulerContent /></HydrationGate> : <SchedulerContent />;
    $[0] = initialReason;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const content = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FeedbackButton className={styles.feedbackBtnDesktop} />;
    t3 = <Header />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== content) {
    t4 = <IntlProviderWrapper>{t2}{t3}{content}</IntlProviderWrapper>;
    $[4] = content;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== currentFacility || $[7] !== featureFlags.disableExternalConfirmation || $[8] !== featureFlags.enableRecaptcha || $[9] !== initialReason || $[10] !== recaptchaSiteKey || $[11] !== reloadFacilityByCode || $[12] !== restUrl || $[13] !== stateCode || $[14] !== t4) {
    t5 = <SchedulerMachineProvider facility={currentFacility} initialReason={initialReason} stateCode={stateCode} restUrl={restUrl} recaptchaSiteKey={recaptchaSiteKey} enableRecaptcha={featureFlags.enableRecaptcha} disableExternalConfirmation={featureFlags.disableExternalConfirmation} reloadFacilityByCode={reloadFacilityByCode}>{t4}</SchedulerMachineProvider>;
    $[6] = currentFacility;
    $[7] = featureFlags.disableExternalConfirmation;
    $[8] = featureFlags.enableRecaptcha;
    $[9] = initialReason;
    $[10] = recaptchaSiteKey;
    $[11] = reloadFacilityByCode;
    $[12] = restUrl;
    $[13] = stateCode;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}